/**
 * Get bounds of a display object
 * Classic getBounds() doesnt work correctly for objects inside container object origin at (0.5,0.5)
 * 
 * TODO: fix for any origin (not just (0.5, 0.5))
 * 
 * @param view 
 * @returns 
 */
export function GetBounds(
    view: any,
    extrude: number = 0,
    out?: Phaser.Geom.Rectangle
): Phaser.Geom.Rectangle
{
    if (!out) {
        out = new Phaser.Geom.Rectangle();
    }
    out.setTo(
        view.x - extrude - view.displayWidth * 0.5,
        view.y - extrude - view.displayHeight * 0.5,
        view.displayWidth + 2 * extrude,
        view.displayHeight + 2 * extrude
    );
    // container fix: incorrect getBounds for children of a container: 
    // https://github.com/photonstorm/phaser/issues/4580
    if (view.parentContainer instanceof Phaser.GameObjects.Container) {
        out.x += view.displayWidth/2;
        out.y += view.displayHeight/2;
    }

    return out;
}